import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import MuiThemeProviderOrigin from '@material-ui/core/styles/MuiThemeProvider';
import PropTypes from 'prop-types';
import React from 'react';

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
});

const MuiThemeProvider = ({ children }) => <MuiThemeProviderOrigin theme={theme}>{children}</MuiThemeProviderOrigin>;

MuiThemeProvider.propTypes = {
    children: PropTypes.node,
};

MuiThemeProvider.defaultProps = {
    children: null,
};

export { MuiThemeProvider };
